import {
  ATTACK_PATH_EVENT_INSERT,
  ATTACK_PATH_EVENT_REMOVE,
  ATTACK_PATH_EVENTS_RESET,
} from '@root/constants/actionTypes';

const initialState = {
  attackPathSuppressEvents: [],
};

const attackPathReducer = (state = initialState, action) => {
  switch (action.type) {
    case ATTACK_PATH_EVENT_INSERT:
      return {
        ...state,
        attackPathSuppressEvents: [
          ...state.attackPathSuppressEvents,
          ...action.payload.filter(
            newItem =>
              !state.attackPathSuppressEvents.some(existingItem => existingItem.resource_id === newItem.resource_id),
          ),
        ],
      };
    case ATTACK_PATH_EVENT_REMOVE:
      return {
        ...state,
        attackPathSuppressEvents: state.attackPathSuppressEvents.filter(
          event => !action.payload.some(payloadEvent => payloadEvent.resource_id === event.resource_id),
        ),
      };
    case ATTACK_PATH_EVENTS_RESET:
      return {
        ...state,
        attackPathSuppressEvents: [],
      };
    default:
      return state;
  }
};

export default attackPathReducer;
